import { RouterModule, Routes } from '@angular/router';

import { InvitationsAuthGuardService } from '../shared/services/invitations-auth-guard.service';

import { InvitationsComponent } from './invitations/invitations.component';

export const invitationsRoutes: Routes = [
  {
    path: 'invitations',
    component: InvitationsComponent,
    canActivate: [InvitationsAuthGuardService],
  },
];

export const InvitationsRouting = RouterModule.forChild(invitationsRoutes);
